import type { RequiredTraining } from '@/lib/handoff';

/** Session-scoped, in-memory state carried from the opener URL (NOT the token — that's in bozp-token). */
export interface PlayerSession {
  trainings: RequiredTraining[];
  returnUrl: string | null;
  inquiryId: string | null;
  /** Embed channel ('web' inside the account iframe); null on the mobile deep-link flow. */
  embed: string | null;
  /** Allowlisted origin of the framing app; the postMessage target when embedded. */
  parentOrigin: string | null;
}

let session: PlayerSession = {
  trainings: [],
  returnUrl: null,
  inquiryId: null,
  embed: null,
  parentOrigin: null,
};

export function setSession(s: PlayerSession): void {
  session = s;
}

export function getSession(): PlayerSession {
  return session;
}

/** Mark a training as locally completed within this session (drives the hub 'Vše hotovo' CTA). */
export function markTrainingValid(hazardProfileId: string): void {
  session = {
    ...session,
    trainings: session.trainings.map((tr) =>
      tr.hazardProfileId === hazardProfileId ? { ...tr, status: 'valid' } : tr,
    ),
  };
}
